"use client"

import { useOptionalUserContext } from "../providers/UserAuthProvider/UserProvider"
import { useGetRequest } from "./useRequest"

type ReferralCodeResponse = {
  data: {
    code: string
    url: string
  }[]
}

export function appendReferralCode(url: string, code?: string): string {
  if (!code) return url
  const separator = url.includes("?") ? "&" : "?"
  return `${url}${separator}referral=${code}`
}

export const useReferralCode = () => {
  const userContext = useOptionalUserContext()
  const user = userContext?.user
  const accessToken = userContext?.accessToken

  const { data, isLoading } = useGetRequest<ReferralCodeResponse>(
    {
      path: `v1/users/${user?.id}/referral`,
      headers: accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : {},
    },
    {
      enabled: !!user?.id,
    },
  )

  return {
    code: data?.data?.[0]?.code,
    isLoading,
  }
}
